import incidentActions from 'store/actions/incidents'
import incidentCategoryActions from 'store/actions/incident_category'
import incidentSubcategoryActions from 'store/actions/incident_subcategory'
import incidentLogActions from 'store/actions/incident_logs'
import branchOfficeActions from 'store/actions/branch_office'
import departmentsActions from 'store/actions/departments'
import clientWorkShiftActions from 'store/actions/client_work_shifts'
import unitActions from 'store/actions/units'
import employeeActions from 'store/actions/employees'
import clientActions from 'store/actions/clients'
import chargeTypeActions from 'store/actions/charge_types'
import trailerActions from 'store/actions/trailers'
import companyActions from 'store/actions/companys'

const INCIDENT_FIELDS = ['Incident_Category.fields()']
const INCIDENT_DETAIL_FIELDS = [
    'Incident_Category.fields()',
    'Incident_Subcategory.fields()',
]

const createMatcher = (regex, parser = (match) => match.groups || {}) => (path) => {
    const match = path.match(regex)
    if (!match) return null
    return parser(match)
}

const loadIncidentLogSupportData = async ({ dispatch }) => {
    const [
        incidents,
        chargeTypes,
    ] = await Promise.all([
        dispatch(incidentActions.load({ force: true })),
        dispatch(chargeTypeActions.load()),
        dispatch(branchOfficeActions.load()),
        dispatch(departmentsActions.load()),
        dispatch(clientWorkShiftActions.load()),
        dispatch(unitActions.load()),
        dispatch(employeeActions.load()),
        dispatch(clientActions.load()),
        dispatch(trailerActions.load()),
        dispatch(companyActions.load()),
    ])

    return {
        incidents,
        chargeTypes,
    }
}

export const incidenciasWarmHandlers = [
    {
        id: 'incidencias.incident.list',
        ttlMs: 45000,
        match: createMatcher(/^\/incident$/),
        prefetch: async ({ dispatch }) => {
            const incidents = await dispatch(incidentActions.load({
                page: 1,
                limit: 50,
                params: {
                    fields: INCIDENT_FIELDS,
                },
                force: true,
            }))

            return { incidents }
        },
    },
    {
        id: 'incidencias.incident.new',
        ttlMs: 30000,
        match: createMatcher(/^\/incident\/new$/),
        prefetch: async ({ dispatch, getState }) => {
            const formattedCategories = await dispatch(
                incidentSubcategoryActions.getFormattedCategories({
                    sys_company_id: getState().app.user.sys_company_id,
                })
            )

            return { formattedCategories }
        },
    },
    {
        id: 'incidencias.incident.detail',
        ttlMs: 45000,
        match: createMatcher(/^\/incident\/(?<id>\d+)$/, (match) => ({
            id: parseInt(match.groups.id, 10),
        })),
        prefetch: async ({ dispatch, getState, params }) => {
            const [item, formattedCategories] = await Promise.all([
                dispatch(incidentActions.get(params.id, {
                    params: {
                        fields: INCIDENT_DETAIL_FIELDS,
                    },
                })),
                dispatch(
                    incidentSubcategoryActions.getFormattedCategories({
                        sys_company_id: getState().app.user.sys_company_id,
                    })
                ),
            ])

            return { item, formattedCategories }
        },
    },
    {
        id: 'incidencias.incident_category.list',
        ttlMs: 45000,
        match: createMatcher(/^\/incident_category$/),
        prefetch: async ({ dispatch }) => {
            const categories = await dispatch(incidentCategoryActions.load({
                page: 1,
                limit: 50,
                force: true,
            }))
            return { categories }
        },
    },
    {
        id: 'incidencias.incident_category.new',
        ttlMs: 30000,
        match: createMatcher(/^\/incident_category\/new$/),
        prefetch: async () => ({ warmed: true }),
    },
    {
        id: 'incidencias.incident_category.detail',
        ttlMs: 45000,
        match: createMatcher(/^\/incident_category\/(?<id>\d+)$/, (match) => ({
            id: parseInt(match.groups.id, 10),
        })),
        prefetch: async ({ dispatch, params }) => {
            const [item] = await Promise.all([
                dispatch(incidentCategoryActions.get(params.id)),
                dispatch(incidentSubcategoryActions.get_incident_subcategories(params.id)),
            ])

            return { item }
        },
    },
    {
        id: 'incidencias.incident_log.list',
        ttlMs: 30000,
        match: createMatcher(/^\/incident_log$/),
        prefetch: async ({ dispatch }) => {
            const [incidents] = await Promise.all([
                dispatch(incidentActions.load({
                    params: {
                        fields: INCIDENT_DETAIL_FIELDS,
                    },
                    force: true,
                })),
                dispatch(branchOfficeActions.load()),
            ])

            return { incidents }
        },
    },
    {
        id: 'incidencias.incident_log.new',
        ttlMs: 30000,
        match: createMatcher(/^\/incident_log\/new$/),
        prefetch: async ({ dispatch }) => {
            const supportData = await loadIncidentLogSupportData({ dispatch })
            return { supportData }
        },
    },
    {
        id: 'incidencias.incident_log.detail',
        ttlMs: 30000,
        match: createMatcher(/^\/incident_log\/(?<id>\d+)$/, (match) => ({
            id: parseInt(match.groups.id, 10),
        })),
        prefetch: async ({ dispatch, params }) => {
            const [supportData, item] = await Promise.all([
                loadIncidentLogSupportData({ dispatch }),
                dispatch(incidentLogActions.get(params.id)),
            ])

            return { supportData, item }
        },
    },
]
